export default __webpack_public_path__ + "static/media/Vector.40dd28cf.svg";